import React, { useRef, useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";
import { cl } from "../../../../../utilities/cl";
import {
  showAlertSuccess,
  showAlertError,
  showAlertInfo,
} from "../../../../../store/Alert/actions";
import List from "../../../../../components/DraggableList";
import SvgArrowUpDown from "../../../../../components/SVG/ArrowUpDown";
import SvgDownload from "../../../../../components/SVG/Download";

import Song from "./Songs";

import Button from "../../../../../components/Button";
import Ok from "../../../../../components/SVG/Ok";
import Trash from "../../../../../components/SVG/Trash";
import SvgEdit from "../../../../../components/SVG/Edit";

import AllVideos from "../AllVideos";
import { DragDropContext } from "react-beautiful-dnd";
import {
  addVideosToLists,
  downloadVideos,
} from "../../../../../store/ContentVideolists/actions";

import SongItem from "../AllVideos/Songs";
import {
  toggleSelectedVideo,
  addVideoToList,
  updateVideosPositions,
  sortVideos,
} from "../../../../../store/ContentVideolists/actions";
import {
  loadVideolistsAllById,
  toggleSelectedVideoAll,
} from "../../../../../store/ContentAllVideolists/actions";
import { updateCurrentMark } from "../../../../../store/Marks/actions";

import ElementsGroup from "../../../../../components/ElementsGroup";
import ButtonCircle from "../../../../../components/ButtonCircle";
import SvgPlus from "../../../../../components/SVG/Plus";
import { openModal, closeModal } from "../../../../../store/Modal/actions";
import AllVideolists from "../AllVideolists";
import { getNextSelected } from "../../../../../utilities/getNextSelected";
import { isMobile } from "../../../../../utilities/media";
import AllPublicSongs from "../PlaylistSongs/AllSongs";
import { loadAllPublicVideo } from "../../../../../store/ContentVideolists/actions";
import { store } from "../../../../../connect";
import { effectTypes } from "redux-saga/effects";
import { getMapValueByIndex } from "../../../../../utilities/getMapValueByIndex";
import { MEDIA_BREAKPOINT_LG } from "../../../../../utilities/breakpoints";

import CurrentVideoList from "./CurrentVideoList";
import { debounce } from "../../../../../utilities/debounce";
import { loading } from "../../../../../store/App/actions";

const VideoList = ({
  className = "",
  selectedVideolists,
  allPublicVideos,
  songs,
  selected_video,
  selected_all,
  toggleSelectedVideoAll,
  showAlertSuccess,
  showAlertError,
  showAlertInfo,
  addVideoToList,
  addVideosToLists,
  updateVideosPositions,
  loadVideolistsAllById,
  loadAllPublicVideo,
  loading
}) => {
  const [trackPlaying, setTrackPlaying] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audio, setAudio] = useState(new Audio());

  const currentPlaylistRef = useRef(null);

  const all_public_content_ref = useRef();
  const videolist_content_all_ref = useRef();

  useEffect(() => {
    loadAllPublicVideo();
  }, []);

  const hPlay = ({ trackId, filename }) => {
    if (trackId === trackPlaying) {
      audio.play();
    } else {
      audio.pause();
      setAudio(new Audio(filename));
      setTrackPlaying(trackId);
    }
  };

  const hPause = () => {
    setIsPlaying(false);
    audio.pause();
  };

  const hStop = () => {
    setIsPlaying(false);
  };

  const hRewind = (totime) => {
    if (audio.currentTime > 0) {
      audio.currentTime = totime;
    }
  };

  className = cl(className, "Songs_collapsible");

  useEffect(() => {
    if (selected_all.length > 0) {
      loadVideolistsAllById();
    }
  }, [selected_all[0]]);

  const addVideos = () => {
    loading(true)
    const fromAll = !Boolean(videolist_content_all_ref.current);

    const videolist_items = currentPlaylistRef.current.getVideolistItems();

    let current = videolist_items.map((song) => {
      return song.id;
    });
    let compair = true;

    const selected_video_all = store.getState().videolists_all.selected_video;

    selected_video_all.map((el, index) => {
      if (current.indexOf(el) !== -1) {
        compair = false;
      }
    });

    let already_includes = [];
    selected_video_all.forEach((el) => {
      if (current.indexOf(el) !== -1) {
        already_includes.push(el);
      }
    });

    if (
      selected_video_all.length === already_includes.length &&
      already_includes.length !== 0
    ) {
      showAlertError({
        text:
          already_includes.length > 1
            ? `Все выбранные композиции уже есть в текущем списке`
            : "Выбранная композиция уже есть в текущем списке",
        ms: 3000,
      });
      loading(false)
      return;
    }

    addVideosToLists({
      videolist_ids: selectedVideolists,
      tracks_ids: selected_video_all,
    });

    let selected = selected_video_all;
    if (already_includes.length) {
      showAlertInfo({
        text: `Некоторые из выбранных композиций уже есть в текущем списке. Они не будут повторно добавлены.`,
        ms: 3000,
      });
      selected = selected.filter((id) => already_includes.indexOf(id) !== -1);
    }

    const newTracks = fromAll
      ? all_public_content_ref.current
        ?.getSelectedTracks()
        .filter((song) => selected.indexOf(song.id) !== -1)
      : videolist_content_all_ref.current
        ?.getSelectedTracks()
        .filter((song) => selected.indexOf(song.id) !== -1);

    let videolist_items_update = [...Array.from(videolist_items), ...newTracks];

    void currentPlaylistRef.current.setVideolistItems([
      ...videolist_items_update,
    ]);
  };

  const songRenderItem = (song, index, selected) => ({
    id: song.id,
    name: song.name,
    element: (
      <SongItem
        key={song.id}
        id={song.id}
        name={song.name}
        variant={index % 2 == 0 ? "gray" : ""}
        songs={songs}
        selected={selected}
        tags={song.tags}
        turn={song.turn}
        cliptime={song.cliptime}
        tempo={song.tempo}
        songauthor_name={song.songauthor_name}
        player_name={song.player_name}
        album_name={song.album_name}
        genre_name={song.genre_name}
        mimetype={song.mimetype}
        year={song.year}
        ctime={song.ctime}
        filename={song.filename}
        audio={audio}
        trackPlaying={trackPlaying}
        isPlaying={isPlaying}
        play={hPlay}
        pause={hPause}
        stop={hStop}
        rewind={hRewind}
        showMore
      />
    ),
  });

  const toggleSelectedP = ({ }, e) => {
    // const clickMode = e.target
    // // .closest('[data-click="context"]')
    // console.log({clickMode});
    
    // if (!clickMode) return
    const songTitle = e.target;

    let selected = store.getState().videolists_all.selected_video;

    document.getSelection().removeAllRanges();

    let id = Number(
      songTitle.dataset.songId ||
      songTitle.parentNode.dataset.songId ||
      songTitle.parentNode.parentNode.dataset.songId
    );
    let i = 0;
    let selection_arr = [];

    if (e.nativeEvent.shiftKey) {
      selection_arr = selected;

      e.preventDefault();
      let list;
      if (store.getState().videolists_all.selected.length)
        list = store.getState().videolists_all.songs.values();
      else list = allPublicVideos.values();

      for (let song of list) {
        if (selected[0] === song.id) {
          i = 1;
          continue;
        }

        if (i === 1) {
          if (song.id !== id) {
            selection_arr.push(song.id);
          } else {
            selection_arr.push(song.id);
            break;
          }
        }
      }

      toggleSelectedVideoAll({
        setAll: true,
        id_video: selection_arr,
      });

      // updateCurrentMark()
    }
    if (songTitle && !e.nativeEvent.shiftKey) {
      if (!isNaN(id)) {
        toggleSelectedVideoAll({
          setAll: true,
          id_video: e.nativeEvent.ctrlKey
            ? selected.includes(id)
              ? selected.filter((el) => el !== id)
              : [...selected, id]
            : selected.includes(id)
              ? []
              : [id],
        });
        // updateCurrentMark()
      }
    }
  };

  const loadMorePublicTraks = (fromAll) => {
    if (fromAll) {
      loadAllPublicVideo({ offset: true });
    } else {
      loadVideolistsAllById({ offset: true });
    }
  };

  const handleResult = (result) => {
    console.log({ result });
    let { destination, source } = result;
    if (!destination || !currentPlaylistRef.current) return;

    if (destination.droppableId === `3` && source.droppableId === `3`) return;
    const videolist_items =
      currentPlaylistRef.current?.getVideolistItems() || [];

    if (destination.droppableId === "2" && source.droppableId === "2") {
      const newSongs = [...videolist_items];
      const movedItem = newSongs[source.index];

      // Создаем массив без перемещаемого элемента
      const withoutMoved = [
        ...newSongs.slice(0, source.index),
        ...newSongs.slice(source.index + 1),
      ];

      // Вставляем элемент в новую позицию
      const updatedSongs = [
        ...withoutMoved.slice(0, destination.index),
        movedItem,
        ...withoutMoved.slice(destination.index),
      ];

      console.log({ updatedSongs });
      currentPlaylistRef.current.setVideolistItems([...updatedSongs]);

      return;
    }

    if (destination.droppableId === "2" && source.droppableId === "2") {
      // 1. Создаём копию массива videolist_items
      const newSongs = [...videolist_items];

      // 2. Удаляем элемент из старой позиции и вставляем в новую
      const [movedItem] = newSongs.splice(source.index, 1);
      newSongs.splice(destination.index, 0, movedItem);

      // 3. Получаем массив только из ID (если нужно)
      const songs = newSongs.map((song) => song.id);

      updateVideosPositions({
        id_videolist: selectedVideolists[0],
        songs,
      });

      return;
    }

    const videolist_items_all = Boolean(
      store.getState().videolists_all.selected.length
    )
      ? store.getState().videolists_all.songs
      : store.getState().videolists.allPublicVideos;

    const sort_table =
      store.getState().videolists.currentVideoListTable.sort_field;
    const searched_value = store.getState().search.songs.value;

    if ((sort_table || searched_value) && destination.index) {
      const currentVideolist = store.getState().videolists.currentVideolist;

      let prevItem = videolist_items[destination.index - 1];

      let prevItemCurrentIndex = currentVideolist.songs.findIndex(
        (el) => el.id === prevItem.id
      );

      destination.index = prevItemCurrentIndex + 1;
    }

    const newItem = videolist_items_all[source.index];
    const includes = videolist_items.map((el) => el.id);
    if (includes.indexOf(newItem.id) !== -1) {
      showAlertError({
        text: "Выбранный видеоролик уже есть в текущем списке",
        ms: 3000,
      });
      return;
    }

    if (destination.droppableId === source.droppableId) {
      if (source.droppableId === `2`) {
        let videolist_item = videolist_items[source.index];
        videolist_items.splice(source.index, 1);
        videolist_items.splice(destination.index, 0, videolist_item);
        currentPlaylistRef.current.setVideolistItems([...videolist_items]);
      } else if (destination.droppableId === `3`) {
        showAlertError({
          text: `Для изменения видео списка перетащите видео в верхнюю часть экрана.`,
          ms: 3000,
        });
        return;
      }
    } else {
      if (destination.droppableId !== `3`) {
        let videolist_item_all = videolist_items_all[source.index];
        videolist_items_all.splice(source.index, 1);
        videolist_items.splice(destination.index, 0, videolist_item_all);
        showAlertSuccess({
          text: `Видео "${newItem.name}" добавлено в список`,
          ms: 2000,
        });
        currentPlaylistRef.current.setVideolistItems([...videolist_items]);
        addVideoToList({
          id_videolist: selectedVideolists[0],
          selected_song: videolist_items.map((song) => song.id),
          songs: videolist_items,
        });
      } else {
        showAlertError({
          text: `Для изменения видео списка перетащите видео в верхнюю часть экрана.`,
          ms: 3000,
        });
        return;
      }
    }
  };

  return (
    <>
      <DragDropContext onDragEnd={handleResult}>
        <CurrentVideoList
          ref={currentPlaylistRef}
          selectedVideolists={selectedVideolists}
          selected_video={selected_video}
          audio={audio}
          trackPlaying={trackPlaying}
          isPlaying={isPlaying}
          hPlay={hPlay}
          hPause={hPause}
          hStop={hStop}
          hRewind={hRewind}
        />

        <div className="All_media">
          <AllVideolists onlyOne />
          <AllVideos
            videolist_content_all={
              <AllPublicSongs
                ref={videolist_content_all_ref}
                songRenderItem={songRenderItem}
                toggleSelectedP={toggleSelectedP}
                loadMorePublicTraks={() => loadMorePublicTraks()}
                preset="playlist_video"
              />
            }
            all_public_content={
              <AllPublicSongs
                ref={all_public_content_ref}
                songRenderItem={songRenderItem}
                toggleSelectedP={toggleSelectedP}
                loadMorePublicTraks={loadMorePublicTraks}
                preset="video"
              />
            }
            addVideos={addVideos}
          />
        </div>
      </DragDropContext>
    </>
  );
};

const stateToProps = (state) => ({
  selectedVideolists: [...state.videolists.selected],
  currentVideolist: state.videolists.currentVideolist,
  currentVideolistAll: state.videolists_all.allVideolists.filter(
    (cur) => cur.id === state.videolists_all.selected[0]
  )[0],
  markItems: [...state.marks[state.marks.current].items],
  selected: [...state.videolists.selected],
  selected_video: state.videolists.selected_video,
  selected_all: state.videolists_all.selected,
  allPublicVideos: state.videolists.allPublicVideos,
});
const actionsToProps = {
  toggleSelectedVideo,
  toggleSelectedVideoAll,
  updateCurrentMark,
  showAlertSuccess,
  showAlertError,
  showAlertInfo,
  openModal,
  closeModal,
  addVideoToList,
  addVideosToLists,
  updateVideosPositions,
  downloadVideos,
  sortVideos,
  loadVideolistsAllById,
  loadAllPublicVideo,
  loading
};

export default connect(stateToProps, actionsToProps)(VideoList);
